import React from 'react';  
import { StyledEngineProvider } from '@mui/material/styles';
import SharedLayout from '../../../layouts/sharedLayout';
import BreadcrumbMenu from '../../../layouts/breadcrumbMenu'; 
import { useParams } from 'react-router-dom';    
import CityDetailsForm from './cityDetailsForm';

const CityDetails: React.FC = () => {  
    const { id } = useParams();   
  const breadcrumbItems = [
    { label: 'Dashboard', path: '/' },
    { label: 'City List', path: '/Cities' }
  ];

  if (id) { 
    breadcrumbItems.push({ label: 'Edit City', path: '/City' }); 
  }else{
    breadcrumbItems.push({ label: 'New City', path: '/City' }); 
  }

  return (
     <StyledEngineProvider injectFirst>
      <SharedLayout> 
        <BreadcrumbMenu items={breadcrumbItems} />
        <CityDetailsForm />
      </SharedLayout>
    </StyledEngineProvider>
  );
};

export default CityDetails;